<template>
    <div class="container">
         <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
                <nav class="level is-mobile mt-3">
                        <div class="level-left">
                           
                          <div class="level-item">
                                <h1 class="is-size-4">Differential Counter Log</h1>
                          </div>


                          <div class="level-item">
                            <b-datepicker
                                    v-model="dateReqDifferentialCounterLogModel"
                                    placeholder="Click to select..."
                                    icon="calendar-today"
                                    trap-focus>
                            </b-datepicker>
                          </div>

                          <div class="level-item">
                              <b-button type="is-primary  is-light" outlined
                                          icon-right="magnify"  
                                          @click="searchDifferentialCounterLog"
                                           
                                          />
                          </div>   



                        </div>
                         


                        <div class="level-right">
                            <div class="level-item">
                               <input class="input" type="text" v-model="filterWord" 
                                       placeholder="LN OPD No. OPD Name " 
                                    >  
                            </div>    
                           
                        </div>
                </nav>


            <b-table                        
      
                :data="isEmpty ? [] : dataDifferentialCounterLog_Filter"
                bordered
                striped
                narrowed
                hoverable
                 
                paginated
                pagination-size="is-medium"
                pagination-position="bottom"
                :current-page.sync="currentPage"
                :per-page="perPage"



                focusable
                mobile-cards>

               <b-table-column   label="No"  v-slot="props" >
                    {{props.row.no}}
               </b-table-column>



               <b-table-column   label="LN"  v-slot="props" >
                   <text-highlight :queries="queries"> {{props.row.idlab}} </text-highlight>
               </b-table-column>

               <b-table-column   label="OPD"  v-slot="props" >
                    <text-highlight :queries="queries"> {{props.row.idopd}}  </text-highlight>
               </b-table-column>


               <b-table-column   label="OPD Name"  v-slot="props" >
                   <text-highlight :queries="queries"> {{props.row.name}}  </text-highlight>
               </b-table-column>


               <b-table-column   label="Owner"  v-slot="props" >
                   <text-highlight :queries="queries"> {{props.row.owner_name}} </text-highlight>
               </b-table-column>

               <b-table-column   label="Species"  v-slot="props" >
                    {{props.row.species}}
               </b-table-column>



               <b-table-column   label="Breed"  v-slot="props" >
                    {{props.row.breed}}
               </b-table-column>


               <b-table-column   label="Date"  v-slot="props" >
                    {{props.row.date}}
               </b-table-column>

               <b-table-column   label="Time"  v-slot="props" >
                    {{props.row.time}}
               </b-table-column>


               <b-table-column   label="#"  v-slot="props" >
                     <b-button 
                     @click="viewPayload(props.row.id)"
                     >View Payload</b-button>
               </b-table-column>



               
                            <template slot="empty">
                                    <section class="section">
                                        <div class="content has-text-grey has-text-centered">
                                            <p>
                                                <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                                </b-icon>
                                            </p>
                                            <p>Nothing here.</p>
                                        </div>
                                    </section>
                            </template>   

            </b-table>     


            <DlgDetailPayloadEachTime
                        v-if="isDlgDetailPayloadEachTimeShowing"
                        :isActive ="isDlgDetailPayloadEachTimeShowing"
                        :dataToChild="dataToChild"
                     
                        @close="closeDlgDetailPayloadEachTime"
              
                    />



    </div>
</template>

<script>

import {mapActions, mapMutations, mapState,} from "vuex";
import axios from "axios";
import {getBaseURLforBackEnd , getConfigAxios  }  from '@/utils.js'
import DlgDetailPayloadEachTime from './DlgDetailPayloadEachTime.vue'


export default {
    name : "DifferentialCounterLog",
    components:{
        DlgDetailPayloadEachTime,
    },
    mounted(){
        if(this.dateReqDifferentialCounterLogModel == null){
            //   console.log("mount DifferentialCounterLog")
              axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
              axios.get(`${getBaseURLforBackEnd()}/api/curdatetime`,getConfigAxios())
                    .then( response => {
                        // console.log("call api curdatetime")
                        this.dateReqDifferentialCounterLogModel = new Date( response.data.current_datetime)
                        this.currentPage = 1
                        this.filterWord = ""
                    })
                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })

                         
                    })
        }
    },
    computed:{
        ...mapState({
              access_token : state => state.master_data.access_token,
              dateReqDifferentialCounterLog : state => state.differentialCounterLog.dateReqDifferentialCounterLog ,
              dataDifferentialCounterLog : state => state.differentialCounterLog.dataDifferentialCounterLog ,
        }),



        dateReqDifferentialCounterLogModel:{
            get: function () {
              return this.dateReqDifferentialCounterLog
            },
            set: function (newValue) {
              this.setDateReqDifferentialCounterLog(newValue)
            }
        },
        dataDifferentialCounterLog_Filter(){
            return this.dataDifferentialCounterLog.filter(dat=>{
                  if (
                      
                        (dat.idlab.toUpperCase().indexOf(this.filterWord.toUpperCase()) > -1  
                         || dat.idopd.toUpperCase().indexOf(this.filterWord.toUpperCase()) > -1
                         || dat.name.toUpperCase().indexOf(this.filterWord.toUpperCase()) > -1 
                         || dat.owner_name.toUpperCase().indexOf(this.filterWord.toUpperCase()) > -1 
                        )
                      
                       ){
                  
                        return  dat
                    }
            })
        },

        queries(){
              return this.filterWord.split(" ");
        },


    },
    methods:{
        ...mapMutations({
             setDateReqDifferentialCounterLog : 'differentialCounterLog/setDateReqDifferentialCounterLog',
         }), 

        ...mapActions({
            fetchDataDifferentialCounterLog: 'differentialCounterLog/fetchDataDifferentialCounterLog',
        }),


        closeDlgDetailPayloadEachTime(){
            this.isDlgDetailPayloadEachTimeShowing = false
        },
        searchDifferentialCounterLog(){
            this.isFullScreenLoading = true
            this.fetchDataDifferentialCounterLog()
                .then(()=>{
                     this.isFullScreenLoading = false
                     this.currentPage = 1
                     this.filterWord = ""
                })
                .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        this.isFullScreenLoading = false
                         
                })
        },
        viewPayload(_id){

            this.isFullScreenLoading = true 
            const datTo = {
                   "id" :  _id
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/get_detail_diffcountmachine_log`,datTo,getConfigAxios())
                    .then( (res) => {
                        this.dataToChild = Object.assign({},res.data.data)
                        this.isDlgDetailPayloadEachTimeShowing = true  
                        this.isFullScreenLoading = false
                    })
                    .catch((err)=>{
                        this.isFullScreenLoading = false
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err.message}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                    })




             
        }
    },
    data(){
        return {
            isFullScreenLoading : false,
            isEmpty : false,

            currentPage : 1,
            perPage : 10,

            filterWord : "",


            isDlgDetailPayloadEachTimeShowing : false,
            dataToChild : {},
        }
    }
}
</script>